<template>
    <div class="book-content">
        <span
            class="top-number"
            v-if="mostPopular"
            @click.stop="setCardDescription">
            {{topNumber}}
        </span>
        <v-card data-cy="item-carousel"
            :height="$vuetify.breakpoint.xs ? '140' : '210'"
            :width="$vuetify.breakpoint.xs ? '105' : '156'"
            class="book"
            color="white"
            @click.stop="setCardDescription"
        >
            <v-img
                :src="`https://assets.beereaders.com/lbr/image/${imageSource}/cover_small.jpg?v=${new Date().getTime()}`"
                :height="$vuetify.breakpoint.xs ? '140' : '210'"
                :width="$vuetify.breakpoint.xs ? '105' : '156'"
            />
        </v-card>
    </div>
</template>
<script>
export default {
    data() {
        return {
            // cardDescription: false
        }
    },
    props: ['book', 'imageSource', 'topNumber', 'mostPopular'],
    computed: {
    },
    methods: {
        setCardDescription() {
            this.$root.$emit('toggleDrawer', this.book)
        },
    },
}
</script>

<style lang="scss">

.book-content {
    height: 140px;
    width: 105px;
    position: relative;
    align-content: center;
    justify-content: center;
    &-active{
        width: 450px;
    }
    @media screen and (min-width: 600px) {
        width: 156px;
        height: 210px;
    }
}
.slick-slide:not(:first-child){
    margin: 0 5px;
    @media screen and (min-width: 600px) {
        margin: 0 12px;
    }
}
.slick-slide:first-child{
    margin: 0 5px 0;
    @media screen and (min-width: 600px) {
        margin: 0 12px 0 0;
    }
}
.popular {
    .slick-slide:not(:first-child){
        margin: 0 1rem;
    }
    .book {
        filter: drop-shadow(6px 0px 12px rgba(0, 0, 0, 0.15));
        .v-image{
            position: absolute;
            top: 0;
            right: 0;
        }
    }
    .book-content{
        height: 100%;
        display: flex;
        justify-content: flex-end;
        margin-left: 16px;
        position: relative;
        width: 100%;
        @media screen and (max-width: 599px) {
            height: 140px;
            width: 105px;
        }
    }
    .top-number{
        background: linear-gradient(310.15deg, rgba(162, 149, 218, 0.8) -3.77%, rgba(119, 100, 202, 0.8) 29.51%, rgba(104, 87, 178, 0.8) 65.63%, rgba(81, 69, 133, 0.8) 93.49%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        color: #a295dab3;
        font-size: 7rem;
        font-weight: 700;
        line-height: 90%;
        position: absolute;
        left: -20px;
        bottom: -1rem;
        text-shadow: 4px 0px 12px rgba(81, 69, 133, 0.2);
        z-index: 2;
        @media screen and (min-width: 600px) {
            font-size: 8.5rem;
        }
    }
}
.content-behind {
    position: absolute;
    top: 25px;
    left: 25px;
}

.text-description {
    font-size: 13px;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}

.no-uppercase {
    text-transform: none;
}

.title-text {
    margin-top: -12px;
    font-size: 20px;
    font-weight: bold;
    color: rgba(60, 0, 0, 0.8);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
</style>
